import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import SearchIcon from 'material-ui-icons/Search';
import { withStyles } from 'material-ui/styles';
import keycode from 'keycode';
import { connect } from 'react-redux';

const styles = theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    paddingTop: 6,
    marginBottom: 12,
  },
  icon: {
    position: 'absolute',
    left: 0,
    top: 28,
    width: 20,
    height: 20,
    color: 'rgba(0,0,0,0.5)',
  },
  text: {
    textIndent: 30,
    paddingLeft: '23px',
  },
  input: {
    padding: '0px 0 9px 30px',
  },
});

class SearchField extends Component {
  onChange = event => {
    const { onSearchChange } = this.props;
    onSearchChange(event);
  };

  onKeyDown = event => {
    if (keycode(event) === 'esc') {
      const { onSearchChange } = this.props;
      event.target.value = '';
      onSearchChange(event);
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <SearchIcon className={classes.icon} />
        <TextField
          fullWidth
          className={classes.text}
          InputProps={{ disableUnderline: true }}
          onChange={this.onChange}
          onKeyDown={this.onKeyDown}
          value={this.props.inputValue}
          label={'Hae raportin ID:tä, sarjanumeroa, tuoteryhmää…'}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    inputValue: state.entities.reports.search,
  };
};

const ConnectedSearchField = connect(mapStateToProps)(SearchField);
export default withStyles(styles)(ConnectedSearchField);



// WEBPACK FOOTER //
// ./src/modules/common/components/table/SearchField.js